import { EUserActions } from '../../actions/user';
import { IUser } from '../../types/currentUser';

export interface IFetchUserData {
  type: EUserActions.fetchUserDataSuccess;
  user: IUser | null;
}

export interface IFetchUserDataError {
  type: EUserActions.fetchuserDataError;
}

export type TUserState = IUser | null;

export function user(state: IUser | null = null, action: IFetchUserData | IFetchUserDataError) {
  switch (action.type) {
    case EUserActions.fetchUserDataSuccess:
      return action.user;
    case EUserActions.fetchuserDataError:
      return state;
    default:
      return state;
  }
}
